
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/media-list",
      function () {
        return require("private-next-pages/media/media-list.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media/media-list"])
      });
    }
  